<section *ngIf="scorecard && scorecard.length > 0">
  <h1>Scorecard</h1>
  <h3>
    <inline-edit [ngClass]="{ 'onclick-edit': allowEdits() }" [(ngModel)]="common.course_name" [size]="75" (change)="updateAll($event, 'coursename')" [name]="coursename" [editable]="allowEdits()">
    </inline-edit><br />
    <inline-edit [ngClass]="{ 'onclick-edit': allowEdits() }" [(ngModel)]="common.address" [size]="75" (change)="updateAll($event, 'streetaddress')" [name]="streetaddress" [editable]="allowEdits()">
    </inline-edit>
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
      <span>
        <inline-edit [ngClass]="{ 'onclick-edit': allowEdits() }" [(ngModel)]="common.city" [size]="75" (change)="updateAll($event, 'city')" [name]="city" [editable]="allowEdits()"></inline-edit>,
      </span>
      <span>
        <inline-edit [ngClass]="{ 'onclick-edit': allowEdits() }" [(ngModel)]="common.state" [size]="75" (change)="updateAll($event, 'stateorregion')" [name]="stateorregion" [editable]="allowEdits()">
        </inline-edit>,
      </span>
      <span>
        <inline-edit [ngClass]="{ 'onclick-edit': allowEdits() }" [(ngModel)]="common.zip" [size]="75" (change)="updateAll($event, 'zip')" [name]="zip" [editable]="allowEdits()"></inline-edit>
        <br />
      </span>
    </div>
  </h3>
  <h4 fxLayout="column" fxLayoutAlign="stretch start">
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
      <div fxFlex="60px">Phone:</div>
      <inline-edit [ngClass]="{ 'onclick-edit': allowEdits() }" [(ngModel)]="common.phone_number" [size]="75" (change)="updateAll($event, 'phonenumber')" [name]="phonenumber" [editable]="allowEdits()">
      </inline-edit>
    </div>
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
      <div fxFlex="60px">Fax: </div>
      <inline-edit [ngClass]="{ 'onclick-edit': allowEdits() }" [(ngModel)]="common.fax_number" [size]="75" (change)="updateAll($event,'faxnumber')" [name]="faxnumber" [editable]="allowEdits()">
      </inline-edit>
    </div>
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
      <div fxFlex="60px">Email:</div>
      <inline-edit [ngClass]="{ 'onclick-edit': allowEdits() }" [(ngModel)]="common.email" [size]="75" (change)="updateAll($event,'emailaddress')" [name]="email" [editable]="allowEdits()"></inline-edit>
    </div>
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
      <div fxFlex="60px">Web:</div>
      <inline-edit [ngClass]="{ 'onclick-edit': allowEdits() }" [(ngModel)]="common.url" [size]="75" (change)="updateAll($event,'url')" [name]="url" [editable]="allowEdits()"></inline-edit>
    </div>
  </h4>
  <button mat-stroked-button color="accent" [disabled]="!commonChanged()" (click)="save()" *ngIf="allowEdits() && commonChanged()" style="margin-top: 8px; white-space: nowrap;">
      <i *ngIf="savingCourse" class="fa fa-spinner fa-spin"></i>
      <span *ngIf="!savingCourse">Save Course Info</span>
  </button>
  <table width="100%" style="margin:0px">
    <thead>
      <th style="text-align: left">Tee Name</th>
      <th *ngFor="let hole_nbr of hole_nbr_front">{{hole_nbr}}</th>
      <th>Out</th>
      <th *ngFor="let hole_nbr of hole_nbr_back">{{hole_nbr}}</th>
      <th>In</th>
      <th>Total</th>
    </thead>
    <tbody *ngFor="let tee of scorecard; let i = index">
      <tr class="tee_header">
        <td fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="7px">
          <mat-icon (click)="addTeeBox(i)">add_circle</mat-icon>
          <inline-edit [(ngModel)]="tee.teename" [size]="10" [editing]="editing"></inline-edit>
           - <inline-edit [(ngModel)]="tee.gender" [size]="1" [editing]="editing"></inline-edit>
       </td>
        <td *ngFor="let yards of tee.front_yards"></td>
        <td class="sr-cell" title="Front nine (holes 1-9) slope / rating">
          <span class="sr-pair"><label>S</label><inline-edit [(ngModel)]="tee.front_slope" [size]="3" [editing]="editing"></inline-edit></span>
          <span class="sr-pair"><label>R</label><inline-edit [(ngModel)]="tee.front_rating" [size]="3" [editing]="editing"></inline-edit></span>
        </td>
        <td *ngFor="let yards of tee.back_yards"></td>
        <td class="sr-cell" title="Back nine (holes 10-18) slope / rating">
          <span class="sr-pair"><label>S</label><inline-edit [(ngModel)]="tee.back_slope" [size]="3" [editing]="editing"></inline-edit></span>
          <span class="sr-pair"><label>R</label><inline-edit [(ngModel)]="tee.back_rating" [size]="3" [editing]="editing"></inline-edit></span>
        </td>
        <td class="sr-cell" title="Overall 18-hole slope / rating">
          <span class="sr-pair"><label>S</label><inline-edit [(ngModel)]="tee.slope" [size]="3" [editing]="editing"></inline-edit></span>
          <span class="sr-pair"><label>R</label><inline-edit [(ngModel)]="tee.rating" [size]="3" [editing]="editing"></inline-edit></span>
        </td>
      </tr>
      <tr>
        <td>Yards</td>
        <td *ngFor="let yards of tee.front_yards;let i = index">
          <inline-edit [(ngModel)]="tee.front_yards[i].value" [size]="3" [editing]="editing"></inline-edit>
        </td>
        <td>
          <inline-edit [(ngModel)]="tee.tot_out_yards" [size]="4" [editing]="editing"></inline-edit>
        </td>
        <td *ngFor="let yards of tee.back_yards;let i = index">
          <inline-edit [(ngModel)]="tee.back_yards[i].value" [size]="3" [editing]="editing"></inline-edit>
        </td>
        <td>
          <inline-edit [(ngModel)]="tee.tot_in_yards" [size]="4" [editing]="editing"></inline-edit>
        </td>
        <td>
          <inline-edit [(ngModel)]="tee.length" [size]="4" [editing]="editing"></inline-edit>
        </td>
      </tr>
      <tr>
        <td>Par</td>
        <td *ngFor="let par of tee.front_par;let i = index">
          <inline-edit [(ngModel)]="tee.front_par[i].value" [size]="2" [editing]="editing"></inline-edit>
        </td>
        <td>
          <inline-edit [(ngModel)]="tee.tot_out_par" [size]="3" [editing]="editing"></inline-edit>
        </td>
        <td *ngFor="let par of tee.back_par;let i = index">
          <inline-edit [(ngModel)]="tee.back_par[i].value" [size]="2" [editing]="editing"></inline-edit>
        </td>
        <td>
          <inline-edit [(ngModel)]="tee.tot_in_par" [size]="3" [editing]="editing"></inline-edit>
        </td>
        <td>
          <inline-edit [(ngModel)]="tee.par" [size]="3" [editing]="editing"></inline-edit>
        </td>
      </tr>
      <tr>
        <td>Handicap</td>
        <td *ngFor="let hcp of tee.front_hcp;let i = index">
          <inline-edit [(ngModel)]="tee.front_hcp[i].value" [size]="3" [editing]="editing"></inline-edit>
        </td>
        <td> </td>
        <td *ngFor="let hcp of tee.back_hcp;let i = index">
          <inline-edit [(ngModel)]="tee.back_hcp[i].value" [size]="3" [editing]="editing"></inline-edit>
        </td>
        <td> </td>
        <td> </td>
      </tr>
    </tbody>
  </table>
  <div fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutGap="10px" style="margin-top: 15px;">
    <!-- Admin actions -->
    <button mat-raised-button color="primary" (click)="onUploadScorecard()" *ngIf="isAdmin() && !editing" style="white-space: nowrap;">
      <mat-icon style="margin-right: 4px; font-size: 18px; height: 18px; width: 18px;">cloud_upload</mat-icon>
      Upload Scorecard
    </button>
    <button mat-raised-button color="primary" (click)="edit()" *ngIf="!editing && allowEdits()" style="white-space: nowrap;">
      <mat-icon style="margin-right: 4px; font-size: 18px; height: 18px; width: 18px;">edit</mat-icon>
      Edit All Tees
    </button>
    <!-- Editing actions -->
    <button mat-raised-button color="accent" (click)="save()" *ngIf="editing">
      <i *ngIf="savingCourse" class="fa fa-spinner fa-spin"></i>
      <span *ngIf="!savingCourse">Save All</span>
    </button>
    <button mat-raised-button (click)="getScorecard()" *ngIf="editing && !savingCourse">Cancel</button>
    <!-- Modal edit link -->
    <button mat-raised-button *ngIf="isAdmin() && inModal" (click)="goToEdit()">Edit</button>
    <!-- Non-admin action -->
    <button mat-stroked-button color="warn" (click)="requestRevision()" *ngIf="!editing" style="white-space: nowrap;">
      <i *ngIf="requestingRevision" class="fa fa-spinner fa-spin"></i>
      <span *ngIf="!requestingRevision">Request Revision</span>
    </button>
  </div>
  <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px" style="margin-top: 10px;">
    {{message}}
  </div>
</section>
<section *ngIf="!scorecard" fxLayout="column" fxLayoutAlign="stretch stretch" fxFill>
  <div fxLayout="column" fxLayoutAlign="center center" fxFill>
      <div>Loading Course</div>
      <div>
          <i class="fa fa-spinner fa-spin"></i> 
      </div>
  </div>
</section>